// getWebSlugsAndConfig.bind(this)();

function getWebSlugsAndConfig() {
    const [, root , , accountSlug, projectSlug, taskSlug] = this.$route.path.split('/');

    const isSelfService = root === 'admin';

    const payload = {
        accountSlug: this.$route.params.accountSlug || accountSlug,
        projectSlug: this.$route.params.projectSlug || projectSlug,
        isSelfService,
        taskSlug: this.$route.params.taskSlug || taskSlug,
        basePath: `/accounts/${this.$route.params.accountSlug}/${this.$route.params.projectSlug}/${this.$route.params.taskSlug}`
    };
    if(!this.$route.params.accountSlug){
        delete payload.accountSlug;
    }
    if(!this.$route.params.taskSlug){
        delete payload.taskSlug;
    }
    if(!this.$route.params.projectSlug){
        delete payload.projectSlug;
    }
    return payload;
}

export default getWebSlugsAndConfig;